<template>
    <div>
        <div class="flex-row">
            <h2 class="subHeading">Перелік кандидатів, що стають депутатами за результатами підрахунку.</h2>
            <h2>Політична партія {{ party.name }}</h2>
        </div>
        <div class="d-flex flex-row table-hover">
            <div class="d-flex flex-column centralList">
                <div class="districID">Центральний список</div>
                <ul class="candNames candNames-long">
                    <li v-for="(c,index) in candidates" :key="index"
                        :class="{'alert-success': c.isElected || c.isElectedByOkrug}">
                        {{c.central}}. {{c.pib_skorocheno }}
                    </li>
                </ul>
            </div>
            <div class="d-flex flex-column regularList" v-for="r in +region_config.okrugsAmount" :key="r">
                <div class="districID">Округ {{ r }}</div>
                <ul class="candNames">
                    <li v-for="(c, index) in getSortedOkrugList(r)" :key="index"
                        :class="{'alert-success win': c.isElectedByOkrug}">
                        {{index + 1}}. {{c.pib_skorocheno}} <span class='candTotal'>{{c.voicesForCandidate}}</span>
                    </li>
                </ul>
                    
            </div>


        </div>

    </div>
</template>

<script>
    export default {
        name: "Candidates",
        props: ['party', 'region_config', 'mandat'],
        created() {
            this.getVoicesForCandidates().then(() => this.getCandidates());
        },
        data() {
            return {
                electedCentral: 2,
                candidates: [],
                voices: [],
                isFetching: true
            }
        },
        methods: {
            addVoicesToCandidates() {
                for (let i = 0; i < this.voices.length; i++) {
                    let c = this.candidates
                        .filter(item => item.okrug == this.voices[i].okrug)
                        .sort((a, b) => +a.num_in_okrug - +b.num_in_okrug);

                    for (let j = 0; j < c.length; j++) {
                        let voicesForCandidate = this.voices[i][`sum(c_${j + 1})`];
                        const percents = voicesForCandidate / this.mandat * 100;
                        // this.$set(c[j], 'voicesPercents', percents);
                        c[j].voicesPercents = percents.toFixed(2);
                        this.$set(c[j], 'voicesForCandidate', voicesForCandidate);
                    }
                }
            },

            setElectedByOkrug() {
                for (let i = 0; i < this.region_config.okrugsAmount; i++) {
                    //Скільки людей по окрузі отримали мандати
                    let a = this.party.mandats[i];
                    let c = this.candidates
                        .filter(item => item.okrug == i + 1)
                        .sort((a, b) => +a.num_in_okrug - +b.num_in_okrug)
                        .sort((a, b) => {
                            const okrugA = +a.voicesPercents;
                            const okrugB = +b.voicesPercents;
                            if ((okrugB >= 25 && okrugA >= 25) || (okrugB >= 25 || okrugA >= 25)) {
                                return okrugB - okrugA
                            }
                            return 0
                        });

                    for (let j = 0; j < a; j++) {
                        c[j].isElectedByOkrug = true
                    }
                }
            },

            setElectedCandidates() {
                let mandats = this.party.totalMandats - this.party.okrugMandats;
                for (let i = 0; i < mandats; i++) {
                    if (this.candidates[i].isElectedByOkrug) {
                        mandats += 1;
                    } 
                    this.candidates[i].isElected = true
                }
            },

            isElectedByOkrug(item) {
                return this.electedByOkrugCandidatesIds.includes(item.cand_Id);
            },

            findDuplicates() {
                /*this.electedCentral = this.party.totalMandats - this.party.mandats.reduce((a, b) => a + b);
                let arr = [...this.candidates.filter(item => item.isElected == true)];
                let alertik = [];
                let arr1 = [...this.candidates.filter(item => item.region == 33)];
                for (let i = 0; i < arr1.length; i++) {
                    for (let j = 0; j < arr.length; j++) {
                        if (arr1[i].cand_id == arr[j].cand_id && i <=this.electedCentral ) {
                            console.dir(arr[j]);
                            this.electedCentral += 1;
                            alertik.push(arr[j].candName);
                        }
                    }
                }*/
                console.table('шукаємо дублікати');
            },

            getVoicesForCandidates() {
                let token = sessionStorage.getItem('token');
                let sendData = {
                    'token': token,
                    //тут пишемо що хочемо від сервера
                    'request': 'cand_25',
                    'party': this.party.name,
                    'region': this.region_config.otg_num

                };

                return this.$http.post(this.$URL, sendData).then(response => {
                    if (response.data == 'ERROR') {
                         alert('Помилка оновлення даних: час вашої сесії вичерпано. \nБудь ласка, натисніть кнопку "Вийти" та знову зайдіть у свій обліковий запис');
                    }
                    this.voices = response.data;
                });
            },

            getCandidates() {
                //Отут приклад запиту в базу
                let token = sessionStorage.getItem('token');
                let sendData = {
                    'token': token,
                    //тут пишемо що хочемо від сервера
                    'request': 'candidates',

                    'party': this.party.name,
                    'region': this.region_config.otg_num

                };
                this.$http.post(this.$URL, sendData).then(response => {
                    if (response.data == 'ERROR') {
                         alert('Помилка оновлення даних: час вашої сесії вичерпано. \nБудь ласка, натисніть кнопку "Вийти" та знову зайдіть у свій обліковий запис');
                    }
                    this.candidates = response.data.sort((a, b) => +a.central - +b.central);
                    this.addVoicesToCandidates();
                    this.setElectedByOkrug();
                    this.setElectedCandidates();
                }).catch(err => console.log(err));
            },

            getSortedOkrugList (okrug) {
                const res = this.candidates
                    .filter(item => item.okrug == okrug)
                    .sort((a, b) => +a.num_in_okrug - +b.num_in_okrug)
                    .sort((a, b) => {
                        const okrugA = +a.voicesPercents;
                        const okrugB = +b.voicesPercents;
                        if ((okrugB >= 25 && okrugA >= 25) || (okrugB >= 25 || okrugA >= 25)) {
                            return okrugB - okrugA
                        }
                        return 0
                    });

                return res;
            },
        },
        computed: {
        }
    }
</script>

<style scoped>
    .districID{
        font-size: 13px;
        font-weight: bold;
        margin: 7px 0;
        padding: 2px 0;
        border-bottom: solid 1px #333;
    }
    .candNames{
        list-style: none;
        padding: 0;
        
    }
    .candNames-long {
        max-height: 60vh;
        overflow-y: auto;
    }
    .candNames li{
        font-size: 11px;
        font-weight: 300;
        display: block;
        widows: 100%;
        padding: 2px;
        width: 200px;
    }
    .candNames li:nth-child(odd) {
    background: #fff;
    }
    .candNames li:nth-child(even) {
    background: #f1f1f1;
    }

    .candTotal{
        float: right;
        padding: 0 0 0 5px;
        /* font-weight: 400; */
    }
    .centralList{
        margin: 5px 15px 10px 0;
        padding: 5px;
        /* background: #f0f7e5; */
    }
    .regularList{
        padding: 5px 0;
        margin: 5px 15px 10px 0;
    }
    .subHeading{
        font-weight: 300;
        font-size: 24px;
        margin-top: 40px;
    }
    .alert-success{
        font-weight: bold !important ;
        color: #057d21 !important;
    }
</style>